<div class="page-heading mb-3" style="cursor: pointer;" (click)="onCancel()">
    <button mat-raised-button><mat-icon>arrow_back</mat-icon>Back to all jobs</button></div>
<div class="post-job-container">
    <h2 class="page-heading" *ngIf="!isUpdateJob">Post a Job</h2>
    <h2 class="page-heading" *ngIf="isUpdateJob">Edit Job</h2>
    <div class="row">
        <div class="col-lg-9">
            <form [formGroup]="postJobForm" class="row" style="padding: 20px;" (ngSubmit)='onSubmit()'>
                <div class="col-lg-12">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">Job Title<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font w-100">
                            <input matInput formControlName="title" required placeholder="Enter Job Title" (input)="capitalizeFirstLetter()">
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('title')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Job Title is Required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-12 mb-2 mt-1">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">Add
                            Featured Image<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div class="upload-asset" [style.border]="postJobForm.get('image')?.touched && !postJobForm.get('image')?.valid ? '1px solid red' : ''" (click)="fileInput.click()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event , fileInput,'image')">
                        <img *ngIf="previewImage; else addFilesIcon" [src]="previewImage" alt="logo"
                            class="preview-image">
                        <ng-template #addFilesIcon>
                            <img src="assets/images/add-files.svg" alt="logo" height="20px" width="20px">
                        </ng-template>
                        <input type="file" class="file-input" (change)="onFileSelected($event, 'image')" #fileInput
                            style="display: none;" />
                        <span *ngIf="!isFileInputClickedImage" class="logo-text">
                            Select File
                        </span>
                        <mat-icon *ngIf="isFileInputClickedImage" aria-hidden="false" class="ms-2"
                            aria-label="Example home icon" fontIcon="cancel" (click)="removeLogo($event)"></mat-icon>
                    </div>
                    <mat-error *ngIf="fileSizeErrorImage">
                        <img class="error-icon" loading="eager" alt="" src="./../../assets/images/alert.svg" /> File size not exceeds 10MB
                      </mat-error>
                      <mat-error class="error-message error-msg" *ngIf="postJobForm.get('image')?.hasError('required') && postJobForm.get('image')?.touched">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                        Image is Required
                      </mat-error>
                </div>
                <div class="col-lg-6">
                    <div>
                      <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                        Job Category<span class="text-danger">*</span>
                      </p>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" class="input-font w-100">
                        <input type="text" placeholder="Select Job Category" matInput formControlName="category" [matAutocomplete]="categoryAuto"
                         required>
                        <mat-autocomplete #categoryAuto="matAutocomplete" (optionSelected)="onCategorySelected($event)">
                          <mat-option *ngFor="let jobCategory of filteredJobCategories | async" [value]="jobCategory?.categoryName">
                            {{ jobCategory?.categoryName }}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error class="error-message error-msg" *ngIf="postJobForm.get('category')?.hasError('required')">
                          <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                          Job Category is Required
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <!-- <div *ngIf="showOtherCategoryField">
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                           Other Job Category<span class="text-danger">*</span>
                          </p>
                        <mat-form-field appearance="outline" class="input-font w-100">
                          <form  [formGroup]="otherMasterData">
                          <input matInput placeholder="Enter Other Job Category" formControlName="otherCategory" required  (change)="onMasterDataChange($event, 'Job Category')">
                          </form>
                          <mat-error class="error-message error-msg" *ngIf="otherMasterData.get('otherCategory')?.touched && !otherMasterData.get('otherCategory')?.value">
                            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                            Other Job Category is Required
                          </mat-error>
                        </mat-form-field>
                      </div> -->
                  </div>
                <div class="col-lg-6">
                    <div>
                      <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                        Specialities<span class="text-danger">*</span>
                      </p>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" class="input-font w-100">
                        <input type="text" placeholder="Select Speciality" matInput formControlName="speciality" [matAutocomplete]="specialityAuto" required>
                        <mat-autocomplete #specialityAuto="matAutocomplete" (optionSelected)="onSpecialitySelected($event)">
                          <mat-option *ngFor="let speciality of filteredSpecialities | async" [value]="speciality?.specialty">
                            {{ speciality?.specialty }}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error class="error-message error-msg" *ngIf="postJobForm.get('speciality')?.hasError('required')">
                          <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                          Specialities is Required
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <!-- <div *ngIf="showOtherSpecialityField">
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                           Other Speciality<span class="text-danger">*</span>
                          </p>
                        <mat-form-field appearance="outline" class="input-font w-100">
                          <form  [formGroup]="otherMasterData">
                            <input matInput placeholder="Enter Other Speciality" formControlName="otherSpeciality" required (change)="onMasterDataChange($event, 'Speciality')">
                          </form>
                          <mat-error class="error-message error-msg" *ngIf="otherMasterData.get('otherSpeciality')?.touched && !otherMasterData.get('otherSpeciality')?.value">
                            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                            Other Speciality is Required
                          </mat-error>
                          </mat-form-field>
                      </div> -->
                  </div>
                  <div class="col-lg-12">
                    <div>
                      <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                        Skills Required<span class="text-danger">*</span>
                      </p>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" class="input-font w-100 equipment" [class.equipment_increase]="jobTagOptionsLength > 5"
                       [ngClass]="{'has-error': skillsInputControl.hasError('required') && skillsInputControl.touched}">
                        <mat-chip-listbox #skillChipList>
                          <mat-chip *ngFor="let skill of postJobForm.get('skills')?.value; let i = index" [removable]="true" (removed)="removeSkill(i)">
                            {{ skill }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                          </mat-chip>
                          <input placeholder="Select Skill" matInput [matAutocomplete]="skillAuto" [formControl]="skillsInputControl" #skillInput>
                        </mat-chip-listbox>
                        <mat-autocomplete #skillAuto="matAutocomplete" (optionSelected)="onSkillSelected($event)">
                          <mat-option *ngFor="let skill of filteredSkills | async" [value]="skill.name">
                            {{ skill?.name }}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error class="error-message error-msg" *ngIf="(skillsInputControl.hasError('required') && skillsInputControl.touched) ||  (postJobForm.get('skills')?.value?.length === 0 && skillsInputControl.touched)">
                        <img class="error-icon" src="./../../assets/images/alert.svg" alt="error" loading="lazy" />Skills are required
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <!-- <div *ngIf="showOtherSkillField">
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                           Other Skills<span class="text-danger">*</span>
                          </p>
                        <mat-form-field appearance="outline" class="input-font w-100">
                          <form  [formGroup]="otherMasterData">
                          <input matInput placeholder="Enter Other Skills" formControlName="otherSkills" required (change)="onMasterDataChange($event, 'Other Skills')">
                          </form>
                          <mat-error class="error-message error-msg" *ngIf="otherMasterData.get('otherSkills')?.touched && !otherMasterData.get('otherSkills')?.value">
                            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                            Other Skills is Required
                          </mat-error>
                        </mat-form-field>
                      </div> -->
                  </div>
                <div class="col-lg-6">
                    <div>
                      <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                        Job Type<span class="text-danger">*</span>
                      </p>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" class="input-font w-100">
                        <input type="text" placeholder="Select Job Type" matInput formControlName="jobType" [matAutocomplete]="jobTypeAuto" required>
                        <mat-autocomplete #jobTypeAuto="matAutocomplete" (optionSelected)="onJobTypeSelected($event)">
                          <mat-option *ngFor="let jobType of filteredJobTypes | async" [value]="jobType?.jobType">
                            {{ jobType?.jobType }}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error class="error-message error-msg" *ngIf="postJobForm.get('jobType')?.hasError('required')">
                          <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                          Job Type is Required
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <!-- <div *ngIf="showJobTypeField">
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                           Other Job Type<span class="text-danger">*</span>
                          </p>
                        <mat-form-field appearance="outline" class="input-font w-100">
                          <form  [formGroup]="otherMasterData">
                          <input matInput placeholder="Enter Other Job Type" formControlName="otherJobType" required  (change)="onMasterDataChange($event, 'Job Type')">
                          </form>
                          <mat-error class="error-message error-msg" *ngIf="otherMasterData.get('otherJobType')?.touched && !otherMasterData.get('otherJobType')?.value">
                            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                            Other Job Type is Required
                          </mat-error>
                        </mat-form-field>
                      </div> -->
                  </div>
                <div class="col-lg-6">
                    <div>
                      <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                        Career Level<span class="text-danger">*</span>
                      </p>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" class="input-font w-100">
                        <input type="text" placeholder="Select Career Level" matInput formControlName="careerLevel" [matAutocomplete]="careerLevelAuto" required>
                        <mat-autocomplete #careerLevelAuto="matAutocomplete" (optionSelected)="onCareerLevelSelected($event)">
                          <mat-option *ngFor="let careerLevel of filteredCareerLevels | async" [value]="careerLevel?.experienceLevel">
                            {{ careerLevel?.experienceLevel }}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error class="error-message error-msg" *ngIf="postJobForm.get('careerLevel')?.hasError('required')">
                          <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                          Career Level is Required
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <!-- <div *ngIf="showOtherCarrerLevelField">
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                           Other Carrer Level<span class="text-danger">*</span>
                          </p>
                        <mat-form-field appearance="outline" class="input-font w-100">
                          <form  [formGroup]="otherMasterData">
                            <input matInput placeholder="Enter Other Carrer Level" formControlName="otherCarrerLevel" required  (change)="onMasterDataChange($event, 'Career Level')" >
                          </form>
                          <mat-error class="error-message error-msg" *ngIf="otherMasterData.get('otherCarrerLevel')?.touched && !otherMasterData.get('otherCarrerLevel')?.value">
                            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                            Other Job Type is Required
                          </mat-error>
                        </mat-form-field>
                      </div> -->
                  </div>
                <div class="col-lg-6">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            Years of Experience<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <div class="d-flex flex-row">
                            <div class="w-50 pr-2">
                                <mat-form-field appearance="outline" class="input-font w-100">
                                    <input matInput type="number" step="0.01" min="0" formControlName="experienceFrom" [max]="getValue('experienceTo')" required placeholder="Min (e.g: 1 )">
                                    <mat-error class="error-message error-msg"
                                        *ngIf="postJobForm.get('experienceFrom')?.hasError('required')">
                                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                        Min.Experience Required
                                    </mat-error>
                                    <mat-error *ngIf="postJobForm.get('experienceFrom')?.hasError('pattern')">
                                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                        Only 2 digits before and after the decimal point are allowed.
                                      </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="w-50 pl-2" style="margin-left: 2px;">
                                <mat-form-field appearance="outline" class="input-font w-100">
                                    <input matInput type="number" step="0.01" min="0" formControlName="experienceTo" [min]="getValue('experienceFrom')" required placeholder="Max (e.g: 3 )">
                                    <mat-error class="error-message error-msg"
                                        *ngIf="postJobForm.get('experienceTo')?.hasError('required')">
                                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                        Max.Experience Required
                                    </mat-error>
                                    <mat-error *ngIf="postJobForm.get('experienceTo')?.hasError('pattern')">
                                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                        Only 2 digits before and after the decimal point are allowed.
                                      </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <mat-error *ngIf="postJobForm.hasError('experienceRangeInvalid')">
                          <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                          Max Experience must be greater than or equal to Min Experience.
                        </mat-error>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div>
                      <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                        Degree Level<span class="text-danger">*</span>
                      </p>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" class="input-font w-100">
                        <input type="text" placeholder="Select degree Level" matInput formControlName="degreeLevel" [matAutocomplete]="degreeLevelAuto" required>
                        <mat-autocomplete #degreeLevelAuto="matAutocomplete" (optionSelected)="onDegreeLevelSelected($event)">
                          <mat-option *ngFor="let degreeLevelOptions of filteredDegreeLevels | async" [value]="degreeLevelOptions.degreeLevel">
                            {{ degreeLevelOptions.degreeLevel }}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error class="error-message error-msg" *ngIf="postJobForm.get('degreeLevel')?.hasError('required')">
                          <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                          Degree Level is Required
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <!-- <div *ngIf="showOtherDegreeLevelField">
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                           Other Degree Level<span class="text-danger">*</span>
                          </p>
                        <mat-form-field appearance="outline" class="input-font w-100">
                         <form [formGroup]="otherMasterData">
                          <input matInput placeholder="Enter Other Degree Level" formControlName="otherDegreeLevel" required (change)="onMasterDataChange($event, 'Degree Level')">
                         </form>
                         <mat-error class="error-message error-msg" *ngIf="otherMasterData.get('otherDegreeLevel')?.touched && !otherMasterData.get('otherDegreeLevel')?.value">
                           <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                           Other Degree Level is Required
                         </mat-error>
                        </mat-form-field>
                      </div> -->
                  </div>
                  <div class="col-lg-12">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                          Tags<span class="text-danger">*</span>
                        </p>
                      </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font w-100 equipment"
                            [class.equipment_increase]="jobTagOptionsLength > 5"
                            [ngClass]="{'has-error': tagsInputControl.hasError('required') && tagsInputControl.touched}">

                            <mat-chip-listbox #tagChipList>
                                <mat-chip *ngFor="let tag of postJobForm.get('tags')?.value; let i = index" [removable]="true" (removed)="removeTag(i)">
                                    {{ tag }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                                <input placeholder="Select Tag" matInput [matAutocomplete]="tagAuto" [formControl]="tagsInputControl" #tagInput>
                            </mat-chip-listbox>

                            <mat-autocomplete #tagAuto="matAutocomplete" (optionSelected)="onTagSelected($event)">
                                <mat-option *ngFor="let tag of filteredTags | async" [value]="tag.jobTags">
                                    {{ tag?.jobTags }}
                                </mat-option>
                            </mat-autocomplete>

                            <mat-error class="error-message error-msg" *ngIf="(tagsInputControl.hasError('required') && tagsInputControl.touched) ||
                                (postJobForm.get('tags')?.value?.length === 0 && tagsInputControl.touched)">
                                <img class="error-icon" src="./../../assets/images/alert.svg" alt="error" loading="lazy" />
                                Tags are required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- <div *ngIf="showOtherTagField">
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                           Other Tag<span class="text-danger">*</span>
                          </p>
                        <mat-form-field appearance="outline" class="input-font w-100">
                          <form [formGroup]="otherMasterData">
                          <input matInput placeholder="Enter Other Tags" formControlName="otherTag" required (change)="onMasterDataChange($event, 'Tag')">
                          </form>
                          <mat-error class="error-message error-msg" *ngIf="otherMasterData.get('otherTag')?.touched && !otherMasterData.get('otherTag')?.value">
                            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                            Other Tag is Required
                          </mat-error>
                        </mat-form-field>
                      </div> -->
                </div>

                <div class="col-lg-12">
                    <div class="d-flex">
                        <p class="med-world-basic-font med-world-basic-font__medium input-font m-0" class="label-styles">
                          Job Description<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div >
                        <angular-editor formControlName="description" [config]="config"></angular-editor>
                    </div>
                    <mat-error class="error-message error-msg" *ngIf="postJobForm.get('description')?.hasError('required') && postJobForm.get('description')?.touched">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                        Job Description is Required
                      </mat-error>
                </div>
                <div class="col-lg-12 mt-4">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            Job Details<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <angular-editor formControlName="jobDetails" [config]="config"></angular-editor>
                    </div>
                    <mat-error class="error-message error-msg" *ngIf="postJobForm.get('jobDetails')?.hasError('required') && postJobForm.get('jobDetails')?.touched">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                        Job Details is Required
                      </mat-error>
                </div>

                <div class="col-lg-12 mt-4">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            Company Name<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font w-100">
                            <input matInput type="text" formControlName="company" required placeholder="Enter Company Name">
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('company')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Company Name is Required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-12 mb-2 mt-1">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            Add Company Logo<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div class="upload-asset" (click)="companyLogoInput.click()" (dragover)="onDragOver($event)" [style.border]="postJobForm.get('companyLogo')?.touched && !postJobForm.get('companyLogo')?.valid ? '1px solid red' : ''"
                        (dragleave)="onDragLeave($event)" (drop)="onDrop($event , companyLogoInput, 'companyLogo')">
                        <img *ngIf="previewCompanyLogo; else addCompanyLogoIcon" [src]="previewCompanyLogo" alt="company-logo"
                            class="preview-image">
                        <ng-template #addCompanyLogoIcon>
                            <img src="assets/images/add-files.svg" alt="logo" height="20px" width="20px">
                        </ng-template>
                        <input type="file" class="file-input" (change)="onFileSelected($event, 'companyLogo')" #companyLogoInput
                            style="display: none;" />
                        <span *ngIf="!isFileInputClickedCompanyLogo" class="logo-text">
                            Select File
                        </span>
                        <mat-icon *ngIf="isFileInputClickedCompanyLogo" aria-hidden="false" class="ms-2" aria-label="Example home icon"
                            fontIcon="cancel" (click)="removeCompanyLogo($event)">
                        </mat-icon>
                    </div>
                    <mat-error *ngIf="fileSizeErrorCompanyLogo">
                        <img class="error-icon" loading="eager" alt="" src="./../../assets/images/alert.svg" /> File size should not exceed 10MB
                    </mat-error>
                    <mat-error class="error-message error-msg"
                        *ngIf="postJobForm.get('companyLogo')?.hasError('required') && postJobForm.get('companyLogo')?.touched">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                        Company Logo is Required
                    </mat-error>
                </div>
                <div class="col-lg-12 mt-2">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            About Company<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <angular-editor formControlName="content" [config]="config"></angular-editor>
                    </div>
                    <mat-error class="error-message error-msg" *ngIf="postJobForm.get('content')?.hasError('required') && postJobForm.get('content')?.touched">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                        About Company is Required
                      </mat-error>
                </div>
                <div class="col-lg-6 mt-4">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">Posted by<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font w-100">
                            <input matInput type="text" formControlName="postedBy" required placeholder="Enter Name">
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('postedBy')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Posted by is Required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-6 mt-4">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">Posted
                            Email Address<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font w-100">
                            <input matInput formControlName="postedEmail" type="email" required placeholder="Enter Valid Email">
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('postedEmail')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Posted Email Address is Required
                            </mat-error>
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('postedEmail')?.hasError('email')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Please enter valid email address
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            Total Positions<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font w-100">
                            <input matInput type="text" formControlName="totalPositions" required placeholder="Enter Total Positions">
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('totalPositions')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Total Positions is Required
                            </mat-error>
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('totalPositions')?.hasError('pattern')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Please enter numbers only
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-12">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">Address<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font w-100">
                            <input matInput formControlName="address" required placeholder="Enter Address">
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('address')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Address is Required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            Country<span class="text-danger">*</span>
                        </p>

                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font w-100">
                            <input type="text" placeholder="Select" aria-label="Number" matInput
                                formControlName="country" #autoCompleteCountryInput="matAutocompleteTrigger"
                                [matAutocomplete]="countryAuto">
                            <mat-autocomplete #countryAuto="matAutocomplete"
                                (optionSelected)="onCountrySelected($event)">
                                <mat-option *ngFor="let option of countryDropdown" [value]="option?.countryName">
                                    {{ option?.countryName }}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('country')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Country is Required
                            </mat-error>
                            <span class="custom-dropdown-arrow">&#9662;</span>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            State<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font w-100">
                            <input type="text" placeholder="Select" aria-label="Number" matInput formControlName="state"
                                [matAutocomplete]="stateAuto">
                            <mat-autocomplete #stateAuto="matAutocomplete" (optionSelected)="onStateSelected($event)">
                                <mat-option *ngFor="let option of stateDropdown" [value]="option?.stateName">
                                    {{ option?.stateName }}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('state')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                State is Required
                            </mat-error>
                            <span class="custom-dropdown-arrow">&#9662;</span>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            City<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="fields input-font w-100">
                            <input type="text" placeholder="Select" aria-label="Number" matInput formControlName="city"
                                [matAutocomplete]="cityAuto">
                            <mat-autocomplete #cityAuto="matAutocomplete">
                                <mat-option *ngFor="let option of cityDropdown" [value]="option?.cityName">
                                    {{ option?.cityName }}

                                </mat-option>
                            </mat-autocomplete>
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('city')?.hasError('required')"><img class="error-icon"
                                    loading="eager" alt="" src="./../../assets/images/alert.svg" /> City is
                                Required</mat-error>
                                <span class="custom-dropdown-arrow">&#9662;</span>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-12 mb-3">
                    <div class="form-check form-switch d-flex">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="hideSalary"
                        formControlName="hideSalary"
                        >
                      <label class="form-check-label" for="hideSalary" >Hide Salary</label>
                    </div>
                  </div>

                <div class="col-lg-3">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            Salary Currency<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="fields input-font w-100">
                            <input
                              type="text"
                              placeholder="Select"
                              matInput
                              formControlName="salaryCurrency"
                              [matAutocomplete]="autoCurrency"
                              maxlength="3"
                              class="uppercase-input">

                            <mat-autocomplete #autoCurrency="matAutocomplete" [displayWith]="displayCurrency" (optionSelected)="onCurrencySelected($event)">
                              <mat-option *ngFor="let item of filteredCurrencies | async" [value]="item">
                                {{ item.currency }}
                              </mat-option>
                            </mat-autocomplete>

                            <mat-error class="error-message error-msg"
                             *ngIf="postJobForm.get('salaryCurrency')?.hasError('invalidCurrency') || !currencySelected || postJobForm.get('salaryCurrency')?.hasError('required')">
                             <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg">
                              Invalid currency.
                            </mat-error>
                          </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-3">
                    <div>
                      <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                        Salary Range<span class="text-danger">*</span>
                      </p>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" class="input-font w-100">
                        <input type="text" placeholder="Select Salary Range" matInput formControlName="salaryRange" [matAutocomplete]="salaryRangeAuto" required>
                        <mat-autocomplete #salaryRangeAuto="matAutocomplete" (optionSelected)="onSalaryRangeSelected($event)">
                          <mat-option *ngFor="let salaryRange of filteredSalaryRanges | async" [value]="salaryRange">
                            {{ salaryRange }}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error class="error-message error-msg" *ngIf="postJobForm.get('salaryRange')?.hasError('required')">
                          <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                          Salary Range is Required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                <div class="col-lg-3">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            Salary From<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font w-100">
                            <input matInput type="text" formControlName="salaryFrom" placeholder="Enter Salary From"
                                [max]="getValue('salaryTo')" required>
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('salaryFrom')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Salary From is Required
                            </mat-error>
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('salaryFrom')?.hasError('pattern')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Please enter numbers only
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-3">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            Salary To<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font w-100">
                            <input matInput type="text" formControlName="salaryTo" [min]="getValue('salaryTo')"
                                required placeholder="Enter Salary To">
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('salaryTo')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Salary To is Required
                            </mat-error>
                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('salaryTo')?.hasError('pattern')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Please enter numbers only
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <mat-error *ngIf="postJobForm.hasError('salaryRangeInvalid')">
                      <img class="error-icon" src="./../../assets/images/alert.svg" />
                      Max Salary must be greater than or equal to Min Salary.
                    </mat-error>
                </div>



                <div class="col-lg-6">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            Application Start Date<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                            <input matInput [matDatepicker]="applicationStartDate"
                                formControlName="applicationStartDate" placeholder="mm/dd/yyyy" required>
                            <mat-datepicker-toggle matIconSuffix [for]="applicationStartDate"></mat-datepicker-toggle>
                            <mat-datepicker #applicationStartDate color="primary"></mat-datepicker>

                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('applicationStartDate')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Application Start Date is Required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div>
                        <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
                            Application Close Date<span class="text-danger">*</span>
                        </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                            <input matInput [matDatepicker]="applicationCloseDate"
                                formControlName="applicationCloseDate" placeholder="mm/dd/yyyy" required>
                            <mat-datepicker-toggle matIconSuffix [for]="applicationCloseDate"></mat-datepicker-toggle>
                            <mat-datepicker #applicationCloseDate color="primary"></mat-datepicker>

                            <mat-error class="error-message error-msg"
                                *ngIf="postJobForm.get('applicationCloseDate')?.hasError('required')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                Application Close Date is Required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-12 mb-3">
                    <div class="form-check form-switch d-flex">
                      <input class="form-check-input" type="checkbox" id="postAnonymously"
                             formControlName="postAnonymously" >
                      <div class="form-check-label" for="postAnonymously" >
                        Hide my company details (Post anonymously)
                      </div>
                    </div>
                  </div>

                <div class="button-container">
                    <button type="submit" class="button button-primary"  *ngIf="!isUpdateJob">Publish Job</button>
                    <button type="submit" class="button button-primary"  *ngIf="isUpdateJob">Update Job</button>
                    <button type="button" class="button button-primary" (click)="onPreview()"
                        *ngIf="!isUpdateJob">Preview</button>
                    <button style="height: 40px;" type="button" class="button button-inverse"
                        (click)="onCancel()">Cancel</button>
                </div>

            </form>

        </div>
    </div>

</div>
